import type { TestimonialsFields } from './types'

export const testimonialsMockData: TestimonialsFields = {
  heading: "Don't just take our word for it",
  testimonials: [
    {
      quote:
        'Exceptionally high quality ingredients, superb meat, great big portions. No waste - one of the best bits - and a significant saving on our weekly food bill. Super excited when the box arrives each week!',
      author: 'Rachel, Leeds',
    },
    {
      quote:
        'The biggest plus is that Gousto has simplified our lives, and to be honest I was shocked by how much time I was spending shopping for food, menu planning and cooking each evening.',
      author: 'Millie, Cornwall',
    },
    {
      quote:
        "I love it. I was getting so sick of my 15-dish repertoire! Now, I eat food I wouldn't normally cook and we don't waste any food. My partner and I are both super happy with Gousto — can't wait for next week's box!",
      author: 'Claudia, Leeds',
    },
  ],
}
